import { Alert, Typography } from "@mui/material";
import { useGetManyReference } from "react-admin";
import { CreateTheoryLessonForm } from "../AddAppointmentDialog/CreateTheoryLessonForm";
import { TheoryLesson } from "../../model/autovioCalendarEvents";
import { LoadingIndicator } from "../../misc/LoadingIndicator";
import { Student } from "../../providers/studentsProvider";

const _newTheoryLessonWarning =
  "Achtung: Hierdurch wird eine neue Theoriestunde angelegt! Besser wäre es, den Fahrschüler zu einer bereits bestehenden Theorie\u00ADstunde hinzuzufügen.";

export function DocumentHistoricalTheoryLessonForm({
  student,
  onSuccess,
}: {
  student: Student;
  onSuccess: () => void;
}) {
  const { data: theoryLessons = [], isLoading } = useGetManyReference<TheoryLesson>("theoryLessons", {
    target: "studentUids",
    id: student.id,
    pagination: { page: 1, perPage: 1 },
    sort: { field: "start", order: "DESC" },
  });
  const lastTheoryLesson = theoryLessons[0];

  if (isLoading) {
    return <LoadingIndicator />;
  }

  return (
    <>
      <Alert severity="warning" sx={{ mb: 2, alignItems: "center" }}>
        <Typography variant="body2">{_newTheoryLessonWarning}</Typography>
      </Alert>
      <CreateTheoryLessonForm
        isHistoricalLesson
        student={student}
        initialDateTime={lastTheoryLesson?.start}
        instructorId={lastTheoryLesson?.instructorId}
        branchId={lastTheoryLesson?.branchId}
        bookedTrainingId={
          lastTheoryLesson?.students?.[student.id]?.bookedTrainingIds?.[0] ?? student.bookedTrainings?.[0]?.id
        }
        onSuccess={onSuccess}
      />
    </>
  );
}
